import React, { useEffect } from "react";
import { useDocumentMeta, useI18n } from "../i18n";
import { posts, postsForLocale } from "./posts";
import BlogCard from "./BlogCard";

export default function BlogIndex() {
  const { t, locale } = useI18n();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useDocumentMeta({
    title: `${t.blog.title} — NewFW`,
    description: t.meta.description,
    path: "/blog",
  });

  const visiblePosts = postsForLocale(posts, locale);

  return (
    <main className="nfw-blog-page">
      <section className="nfw-section nfw-section-alt">
        <div className="nfw-wrap">
          <div className="nfw-section-head">
            <div>
              <p className="nfw-kicker">{t.blog.kicker}</p>
              <h1 className="nfw-h2">{t.blog.title}</h1>
            </div>
            <p className="nfw-lead">{t.blog.subtitle}</p>
          </div>
          <div className="nfw-blog-grid">
            {visiblePosts.map((post) => (
              <BlogCard
                key={post.slug}
                post={post}
                locale={locale}
                readMore={t.blog.readMore}
              />
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
